import React, { useEffect } from 'react'

import { WizardHeader } from '../../../../../../components/Elements/Modal/components/WizardHeader/WizardHeader'
import { useGetPlatforms } from '../../../../api/getPlatforms'
import { ConnectionModalProps, platformWizardSteps } from '../../../common/Common.models'
import { ConnectionModalContainer } from '../../../common/Common.styled'
import { useSteps } from '../../../../hooks/useSteps'
import { CONNECTION_STATUS } from '../../../../models'
import usePlatformsModalsStore from '../../../../stores/platformsModals.store'

import { GoogleConnectModalContent } from './GoogleConnectModalContent'

export const GoogleConnectionModal = ({
  connectionStatus,
  isEdit,
  onClose,
}: ConnectionModalProps) => {
  const stepsForPlatform = platformWizardSteps.google.steps
  const { data: platforms } = useGetPlatforms()
  const { selectedConnectionId } = usePlatformsModalsStore()
  const googleConnections = platforms?.filter(
    ({ platformType }) => platformType.toLowerCase() === 'google'
  )

  const getPlatformById = (id: number) => {
    return platforms?.find((platform) => platform.connectionId === id)
  }

  const onlyOneGoogleConnection = googleConnections?.length === 1

  const getInitialStep = () => {
    /*
      Taking care of situations, than user didn't finish connection process and closed modal
      So we checking what's the [connectionStatus] and [platform] and returning initial step according to it
    */
    if (selectedConnectionId) {
      const platform = getPlatformById(selectedConnectionId)

      if (!platform) return 1
      return platform.connectionStatus === CONNECTION_STATUS.CONNECTED ? 3 : 2
    } else if (
      isEdit &&
      onlyOneGoogleConnection &&
      googleConnections[0].connectionStatus !== CONNECTION_STATUS.DISCONNECTED
    ) {
      return googleConnections[0].connectionStatus === CONNECTION_STATUS.PENDING ? 2 : 3
    } else if (
      // if user opens connection modal for SSO -> he cant add another one and it will be edit
      // in case he opens connection modal with MCC connection -> he can add another one
      // to edit previously added MCC connection -> pass selectedConnectionId through zustand store
      onlyOneGoogleConnection &&
      googleConnections[0].connectionStatus !== CONNECTION_STATUS.DISCONNECTED &&
      googleConnections[0].connectionType === 'SSO'
    ) {
      // if it's only one connection and it's not pending -> user need to edit ad accounts
      return googleConnections[0].connectionStatus === CONNECTION_STATUS.PENDING ? 2 : 3
    } else {
      return connectionStatus === CONNECTION_STATUS.PENDING && googleConnections?.length === 1
        ? 2
        : 1
    }
  }

  useEffect(() => {
    setStep(getInitialStep())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const stepByStatus = getInitialStep()

  const selectedConnection = selectedConnectionId
    ? getPlatformById(selectedConnectionId)
    : undefined

  const blockedSteps =
    connectionStatus === CONNECTION_STATUS.CONNECTED ||
    (selectedConnection && selectedConnection.connectionStatus === CONNECTION_STATUS.CONNECTED)
      ? [2]
      : undefined

  const { setStep, onBack, currentStep } = useSteps({
    initialStep: stepByStatus,
  })
  return (
    <ConnectionModalContainer id={'google-connection-modal'}>
      <WizardHeader
        onChangeStep={setStep}
        currentStep={currentStep}
        steps={stepsForPlatform}
        blockedSteps={blockedSteps}
      />
      <GoogleConnectModalContent
        setStep={setStep}
        currentStep={currentStep}
        onBack={onBack}
        editAccount={
          onlyOneGoogleConnection ? googleConnections[0].connectionId : selectedConnectionId
        }
        onClose={onClose}
        isEdit={isEdit}
      />
    </ConnectionModalContainer>
  )
}
